var instance = null;

var FILTER_KEY = "FILTER_KEY";

function FilterManager() {
    if (instance !== null) {
        throw new Error('Cannot instantiate more than one FilterManager.');
    }
}

FilterManager.prototype.getCurrentFilters = function () {
    var filters = sessionStorage.getItem(FILTER_KEY);
    var result;
    if (!_.isEmpty(filters)) {
        result = JSON.parse(filters);
    } else {
        result = {};
    }
    return result;
};

FilterManager.prototype.setCurrentFilters = function (filters) {
    sessionStorage.setItem(FILTER_KEY, filters);
};

FilterManager.getInstance = function() {
    if (instance === null) {
        instance = new FilterManager();
    }
    return instance;
};

export default FilterManager.getInstance();
